
















import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
// Types
import { ILanguage } from "@/models/constants";
import { IState } from "@/store";
// Mixins
import RequestPromises from "@/mixins/requestPromises";
import { getLocaleCountryCode } from "@/data/enums/i18n";

@Component({
  computed: {
    ...mapState({
      languages: (state: IState) => state.constants.languages
    })
  }
})
export default class BrandLanguages extends Mixins(RequestPromises) {
  // Props

  @Prop({ required: true })
  public value!: ILanguage["id"][];

  @Prop({ required: true })
  public brandLanguageId!: ILanguage["id"];

  @Prop({ required: true })
  public isProcessing!: boolean;

  // Vuex Bindings

  public languages!: ILanguage[];

  //  Computed

  public get selected() {
    return this.$_.union(this.value, [this.brandLanguageId]);
  }

  public set selected(value) {
    this.$emit("input", this.$_.union(value, [this.brandLanguageId]));
  }

  // Life-cycle methods

  public async created() {
    await this.$store.dispatch("constants/getLanguages");
  }

  // Methods

  public getLocaleCountryCode(code: ILanguage["code"]) {
    return getLocaleCountryCode(code);
  }
}
